var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner-five"},[_c('h2',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}]},[_vm._v("云昇新控官网-重庆云昇新控智能科技有限公司")])])
}
var staticRenderFns = []

export { render, staticRenderFns }